export default __webpack_public_path__ + "static/media/marauders-map-v4-gallery-10.a7fbc60a.jpg";